import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularSplitModule } from 'angular-split';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './admin/sidebar/sidebar.component';
import { CabecalhoProdutoComponent } from './detalhamento-produto/detalhamento/cabecalho/cabecalho-produto.component';
import { BeneficiosComponent } from './detalhamento-produto/detalhamento/beneficios/beneficios.component';
import { CasesComponent } from './detalhamento-produto/detalhamento/cases/cases.component';
import { DepoimentosComponent } from './detalhamento-produto/detalhamento/depoimentos/depoimentos.component';
import { DesenvolvidoPorComponent } from './detalhamento-produto/detalhamento/desenvolvido-por/desenvolvido-por.component';
import { DemonstracaoComponent } from './detalhamento-produto/detalhamento/header/disponibilizacao-licenciamento/demonstracao/demonstracao.component';
import { DisponibilizacaoLicenciamentoComponent } from './detalhamento-produto/detalhamento/header/disponibilizacao-licenciamento/disponibilizacao-licenciamento.component';
import { HeaderComponent } from './detalhamento-produto/detalhamento/header/header.component';
import { HighlightsComponent } from './detalhamento-produto/detalhamento/header/highlights/highlights.component';
import { MaisInformacoesComponent } from './detalhamento-produto/detalhamento/mais-informacoes/mais-informacoes.component';
import { PerguntasComponent } from './detalhamento-produto/detalhamento/perguntas/perguntas.component';
import { PowerNumbersComponent } from './detalhamento-produto/detalhamento/power-numbers/power-numbers.component';
import { SimilaresComponent } from './detalhamento-produto/detalhamento/similares/similares.component';
import { VideoComponent } from './detalhamento-produto/detalhamento/video/video.component';
import { DetalhamentoComponent } from './detalhamento-produto/detalhamento/detalhamento.component';
import { DndModule } from 'ng2-dnd';
import { ProductAdminComponent } from './admin/product-admin/product-admin.component';
import { AdminComponent } from './admin/admin.component';
import { ProdutosService } from './admin/services/produtos.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AreasService } from './admin/services/areas.service';
import { DesenvolvedoresService } from './admin/services/desenvolvedores.service';
import { RodapeModule } from './rodape/rodape.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { environment } from '../environments/environment';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics'

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    CabecalhoProdutoComponent,
    ProductAdminComponent,
    HeaderComponent,
    VideoComponent,
    DisponibilizacaoLicenciamentoComponent,
    PowerNumbersComponent,
    BeneficiosComponent,
    MaisInformacoesComponent,
    CasesComponent,
    DepoimentosComponent,
    PerguntasComponent,
    DesenvolvidoPorComponent,
    SimilaresComponent,
    HighlightsComponent,
    DemonstracaoComponent,
    DetalhamentoComponent,
    AdminComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    NgxGoogleAnalyticsModule.forRoot(environment.gaKey),
    NgxGoogleAnalyticsRouterModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    AngularSplitModule,
    DndModule.forRoot(),
    NgbModule,
    RodapeModule
  ],
  providers: [
    ProdutosService,
    AreasService,
    DesenvolvedoresService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
